<a
  mat-list-item
  [ngStyle]="{ 'padding-left': 16 + depth * 16 + 'px' }"
  (click)="onItemSelected(item)"
  [ngClass]="{
    active: isItemActive(item),
    expanded: expanded
  }"
  class="menu-list-item"
>
  <mat-icon class="routeIcon" style="margin-right: 3px;">{{ item.Icon }}</mat-icon>
  {{ item.Title }}
  <span fxFlex *ngIf="item.Nodes && item.Nodes.length">
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
      expand_more
    </mat-icon>
  </span>
</a>
<div *ngIf="expanded">
  <app-menu-list-item
    *ngFor="let child of item.Nodes"
    [item]="child"
    [depth]="depth + 1"
  >
  </app-menu-list-item>
</div>
